module.exports = __webpack_public_path__ + "media/images/send_ok-91f6bc782e276335d85799faf6f69c78.svg";